import {AOperation} from "../../models/operations/AOperation";
import {EOperationType} from "../../models/utils/EOperationType";
import CustomMarker from "../../components/map/marker/CustomMarker";
import {LatLng} from "leaflet";
import OperationPopup from "../../components/map/marker/OperationPopup";
import ModalInPopup from "../../components/map/marker/ModalInPopup";

class MarkersService {

    public generateMarkersFromOperations(operations: AOperation[], filter?: EOperationType): JSX.Element[] {
        let markers: JSX.Element[] = [];
        let filteredOperations = operations;
        if(filter !== undefined) {
            filteredOperations = operations.filter(operation => operation.type === filter);
        }
        for(let i = 0; i < filteredOperations.length; i++) {
            let marker = this.generateMarkerFromOperation(filteredOperations[i]);
            if(marker !== undefined) {
                markers.push(marker);
            }
        }
        return markers;
    }

    public generateMarkerFromOperation(operation: AOperation): JSX.Element | undefined {
        let marker = undefined;
        if(operation.geolocation !== undefined) {
            const position = new LatLng(operation.geolocation.latitude, operation.geolocation.longitude);
            const icon = operation.icon.icon;
            const descriptionInPopup = <OperationPopup operation={operation}/>;
            const modal = <ModalInPopup color="secondary" operation={operation}/>
            marker = <CustomMarker elementInModal={modal} position={position} icon={icon} descriptionInPopup={descriptionInPopup}/>;
        }
        return marker;
    }

}

export default new MarkersService();
